import { useServerTranslation } from 'hooks/useServerTranslation';

import { z } from 'zod';

export const useTranslatedCreatePasswordSchema = () => {
    const { t } = useServerTranslation();

    return z.object({
        password: z.string().min(8, { message: t('errors.min.password', { length: 8 }) }),
        password_again: z.string().min(8, { message: t('errors.min.password', { length: 8 }) }),
    });
};
